<!-- <template>
  <v-card class="mx-auto card-option" max-width="370" style="cursor: pointer;width: 29rem;display: flex;"
    @click="ingresar">
    <div style="display: flex;justify-content: center;align-items: center;height: 7rem; background-color: white;border-radius: 1rem !important;width: 7rem;">
      <i :class="[iconoFinal]" style="font-size: 3rem; color: #005dbe;"></i>
    </div>
    <div style="width: 20rem;">
      <v-card-title style="font-size: 1.2rem; padding-top: 1.2rem !important;">
      {{ title }}
    </v-card-title>
    <v-card-subtitle
      style="height: 3rem; color: white; border-color: white !important; font-size: .8rem; line-height: 1rem;">
      {{ detalle_titulo }}
    </v-card-subtitle>
  </div>
  </v-card>
</template>

<script>
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
export default {
  data() {
    return {
      iconoPrueba: "fa-solid fa-user-shield"
    };
  },
  methods: {
    ingresar() {
      this.$router.push(this.url);
    }
  },
  props: {
    title: String,
    detalle_titulo: String,
    url: String,
    icono: {
      type: String,
      default: "" // fallback
    }
  },
  mounted() {
    console.log("Icono recibido desde BD:", this.icono);
  },
  computed: {
  iconoFinal() {
    return this.icono && this.icono.trim() !== ""
      ? this.icono
      : "fa-solid fa-circle-question"; // fallback si BD no trae nada
  }
}
};
</script>
<style>
.icon-3d {
  display: inline-block;
  font-size: 5rem;
  color: #005dbe;
  transform-style: preserve-3d;
  animation: spin3d 3s infinite linear;
}

@keyframes spin3d {
  0% {
    transform: perspective(800px) rotateY(0deg);
  }
  100% {
    transform: perspective(800px) rotateY(360deg);
  }
}

@keyframes spinY {
  0% {
    transform: rotateY(0deg);
  }
  100% {
    transform: rotateY(360deg);
  }
}

.spin-y {
  display: inline-block;
  animation: spinY 2s linear infinite; /* velocidad y repetición */
  transform-origin: center;
}
.card-option {
  border-radius: 1rem !important;
  margin-bottom: 1.9rem;
  background: linear-gradient(135deg, #005dbe, #0062be, #005dc6);
  box-shadow: 5px 10px 10px rgba(0, 0, 0, 0.337),
    -5px -5px 10px rgba(36, 36, 36, 0.324) !important;
  border-radius: 15px;
  color: white !important;
  font-size: 18px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.card-option:hover {
  z-index: 9;
  transform: scale(1.1) rotate(5deg);
  box-shadow: 5px 40px 15px rgba(0, 0, 0, 0.5) !important;
  transform: translateY(-20px);
  box-shadow: 0px 8px 8px 15px rgba(0, 0, 0, 0.526), 0px -8px -8px 15px rgba(3, 3, 3, 0.496);
}

.card-option div {
  border-radius: 1rem 1rem 0 0 !important;
}
</style> -->

<template>
  <v-card 
    class="module-card-clean" 
    style="cursor: pointer;"
    @click="ingresar"
  >
    <div class="card-content-wrapper">
      
      <div class="icon-section">
        <!-- <i :class="[iconoFinal]" style="font-size: 2.2rem; color: #007bff;"></i> -->
        <!-- <font-awesome-icon :icon="iconoFinal" size="lg"  style="font-size: 2.2rem; color: #007bff;"/> -->
        <v-icon dark left style="font-size: 2.2rem; color: #007bff;">mdi-logout</v-icon>
      </div>

      <div class="text-section">
        <v-card-title class="card-title-clean">
          {{ title }}
        </v-card-title>
        
        <v-card-subtitle class="card-subtitle-clean">
          {{ detalle_titulo }}
        </v-card-subtitle>
      </div>
    </div>
  </v-card>
</template>

<script>
// Mantener el script casi intacto
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;

export default {
  // Se elimina data e iconoPrueba ya que no se usan
  methods: {
    ingresar() {
      // Usamos el router de Vuetify
      this.$router.push(this.url);
    }
  },
  props: {
    title: String,
    detalle_titulo: String,
    url: String,
    icono: {
      type: String,
      default: "" 
    }
  },
  computed: {
    iconoFinal() {
      // Fallback a un ícono por defecto si la BD no trae nada
      return this.icono && this.icono.trim() !== ""
        ? this.icono
        : "fa-solid fa-circle-question"; 
    }
  }
};
</script>

<style scoped>
.module-card-clean {
  display: flex;
  align-items: center;
  padding: 0.75rem 0.9rem;
  margin: 0;
  border-radius: 10px !important;
  background-color: #f7f7f7 !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
  transition: all 0.2s ease;
  width: 100%;
  min-height: 76px;
  height: auto;
}

.module-card-clean:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 10px rgba(0, 0, 0, 0.15) !important;
  background-color: #ffffff !important;
}

.card-content-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
  min-width: 0;
}

.icon-section {
  flex-shrink: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background: rgba(0, 123, 255, 0.08);
}

.text-section {
  flex: 1;
  min-width: 0;
  padding-left: 0.85rem;
  text-align: left;
}

.card-title-clean {
  font-size: clamp(0.88rem, 2.2vw, 1rem) !important;
  font-weight: 600 !important;
  color: #333333 !important;
  padding: 0 !important;
  margin: 0 0 0.2rem !important;
  line-height: 1.25 !important;
  white-space: normal !important;
  word-break: break-word;
}

.card-subtitle-clean {
  font-size: 0.75rem !important;
  color: #6c757d !important;
  padding: 0 !important;
  margin: 0 !important;
  line-height: 1.3 !important;
  height: auto !important;
  white-space: normal !important;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media screen and (max-width: 600px) {
  .module-card-clean {
    min-height: 70px;
    padding: 0.7rem 0.8rem;
  }

  .icon-section {
    width: 42px;
    height: 42px;
  }

  .icon-section ::v-deep .v-icon {
    font-size: 1.7rem !important;
  }

  .text-section {
    padding-left: 0.7rem;
  }
}
</style>